import React, { useEffect, useState } from 'react';
import ApiErrorComp from '../../ApiErrorComp/ApiErrorComp';
import ZenGauge from '../Common/Graph/ZenGauge';
import ZenHorBarChart from '../Common/Graph/ZenHorBarChart';
import ZenVerBarChart from '../Common/Graph/ZenVerBarChart';
import liracrypt from '../../Liracrypt/liracrypt';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin, Row, Col } from 'antd';
const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const MdashQtyData = ({ lid, urlData }) => {

    const [chartList, setChartList] = useState([
        { name: 'ZenGaugeToday', data: null, type: 'ZenGauge', span: 4 },
        { name: 'ZenHorBarChartAPQ', data: null, type: 'ZenHorBarChart', span: 4 },
        { name: 'ZenVerBarChartMonth', data: null, type: "ZenVerBarChart", span: 4 },
        { name: 'ZenVerBarChartDay', data: null, type: "ZenVerBarChart", span: 12 }
    ]);

    const fetchGraphData = () => {
        chartList.forEach((chart, i) => {
            let params = {
                ...urlData, ... {
                    lid: lid ? lid : "lid_999",
                    chartGroup: "ManagerDashBoard2",
                    typ: chart.name
                }
            }
            liracrypt
                .get("/v04/mdash/trenddata", params)
                .then(({ data }) => {
                    const resp = { ...data };
                    let chartData = [...chartList];
                    chartData[i].data = resp['data'][chart.name];
                    setChartList(chartData);
                })
                .catch((error) => {
                    // message.error('ERROR: Unable to save!', 4);
                    console.log(error);
                    if (error.response !== undefined) {
                        if (error.response.status !== 401) {
                            ApiErrorComp(error.response.status);
                        } else {
                            // this.setState({
                            //     ...this.state,
                            //     loginError: true,
                            // });
                        }
                    }
                });
        });
    }

    useEffect(() => {
        fetchGraphData();
    }, [])

    return (
        <div>
            <Row>
                <Col span={4}>
                    <div
                        style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            marginTop: "10px",
                            width: "95%",
                        }}
                    >
                        {
                            chartList[0].data ?
                                <ZenGauge
                                    divId={"ZenGaugeToday"}
                                    data={chartList[0].data.data}
                                    config={chartList[0].data.config}
                                /> :
                                <div className="Loading" style={{ minHeight: "100px" }}>
                                    <Spin indicator={antIcon} />
                                </div>
                        }

                    </div>


                    <div
                        style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            marginTop: "10px",
                            width: "95%"
                        }}
                    >
                        {
                            chartList[1].data ?
                                <ZenHorBarChart
                                    divId={"ZenHorBarChartAPQ"}
                                    data={chartList[1].data.data}
                                    config={chartList[1].data.config}
                                    onChange={(data) => this.changeBasicGraph(data)}
                                /> :
                                <div className="Loading" style={{ minHeight: "100px" }}>
                                    <Spin indicator={antIcon} />
                                </div>
                        }

                    </div>
                </Col>
                <Col span={4}>
                    <div
                        style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            marginTop: "10px",
                            width: "95%"
                        }}
                    >
                        {
                            chartList[2].data ?
                                <ZenVerBarChart
                                    divId={"ZenVerBarChartMonth"}
                                    data={chartList[2].data.data}
                                    config={chartList[2].data.config}
                                    onChange={(data) => this.changeBasicGraph(data)}
                                /> :
                                <div className="Loading" style={{ minHeight: "100px" }}>
                                    <Spin indicator={antIcon} />
                                </div>
                        }

                    </div>
                </Col>
                <Col span={16}>
                    <div
                        style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            marginTop: "10px",
                            width: "100%"
                        }}
                    >
                        {
                            chartList[3].data ?
                                <ZenVerBarChart
                                    divId={"ZenVerBarChartDay"}
                                    data={chartList[3].data.data}
                                    config={chartList[3].data.config}
                                    onChange={(data) => this.changeBasicGraph(data)}
                                /> :
                                <div className="Loading" style={{ minHeight: "100px" }}>
                                    <Spin indicator={antIcon} />
                                </div>
                        }

                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default MdashQtyData;